import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "./header";
import { Footer } from "./footer";
import { Newsletter } from "./Newsletter";
import "./home.css";

export const Home = () => {
  return (
    <div className="home-container">
      <Navbar />
      
      {/* Hero Section */}
      <section className="hero-section">
        <div className="video-container">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            className="hero-video"
          >
            <source src="/resources/images/herovid.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="hero-content">
          <div className="hero-heading-group">
            <h1 className="hero-title">
              Painting Love with Light
            </h1>
            <p className="hero-subtitle">
              Weddings, events, lifestyle and beyond  
            </p>
          </div>
          <Link to="/contactUs" className="cta-button">
            Book a Consultation
          </Link>
        </div>
        <div className="hero-overlay"></div>
      </section>

      {/* Highlighted Creations */}
      <section className="featured-section">
        <div className="section-header">
          <h2 className="section-title">Highlighted Creations</h2>
          <div className="title-line"></div>
        </div>
        <div className="featured-grid">
          <div className="featured-item">
            <img src="/resources/images/pic1.png" alt="Luxury wedding photography" />
            <div className="featured-overlay">
              <h3>Royal Weddings</h3>
              <p>Elegance in Every Frame</p>
            </div>
          </div>
          <div className="featured-item">
            <img src="/resources/images/pic2.png" alt="Premium wedding moments" />
            <div className="featured-overlay">
              <h3>Candid Moments</h3>
              <p>Natural Beauty Captured</p>
            </div>
          </div>
          <div className="featured-item">
            <img src="/resources/images/hero-bg.png" alt="Artistic wedding shots" />
            <div className="featured-overlay">
              <h3>Artistic Vision</h3>
              <p>Creative Perspectives</p>
            </div>
          </div>
        </div>
        <Link to="/gallery" className="view-more-button">
          View Portfolio
        </Link>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="section-header">
          <h2 className="section-title">How does the process work?</h2>
          <div className="title-line"></div>
        </div>
        <div className="process-grid">
          <div className="process-item">
            <div className="process-image">
              <img src="/resources/images/wedding/wedding-portfolio20.jpg" alt="Consultation and Booking" />
            </div>
            <h3>1. Consultation and Booking</h3>
            <p>Share Your Vision: Begin by sharing your wedding vision and requirements with us. Fill out our consultation form to provide us with essential details about your event, style preferences, and photography needs.</p>
          </div>
          <div className="process-item">
            <div className="process-image">
              <img src="/resources/images/wedding/wedding-portfolio21.jpg" alt="Agreement and Confirmation" />
            </div>
            <h3>2. Agreement and Confirmation</h3>
            <p>Seal the Deal: Once we've discussed your vision and tailored a package to your needs, it's time to formalize our partnership. We'll send you a contract outlining the agreed-upon services, terms, and payment schedule. Simply review, sign, and return the contract to confirm your booking.</p>
          </div>
          <div className="process-item">
            <div className="process-image">
              <img src="/resources/images/wedding/wedding-portfolio25.jpg" alt="Capturing Your Moments" />
            </div>
            <h3>3. Capturing Your Moments</h3>
            <p>Let the Magic Begin: On your wedding day, our team will be there to capture every precious moment. From the pre-ceremony jitters to the post-reception celebrations, we'll be behind the lens, ensuring that no moment goes unnoticed. Relax and enjoy your special day while we work our magic.</p>
          </div>
          <div className="process-item">
            <div className="process-image">
              <img src="/resources/images/wedding/wedding-portfolio37.jpg" alt="Delivery of Memories" />
            </div>
            <h3>4. Delivery of Memories</h3>
            <p>Cherish Your Memories: After the excitement of your wedding day has subsided, it's time to relive those cherished moments through your photographs. We'll carefully curate and edit your images to perfection before delivering them to you digitally or in print, depending on your chosen package. Get ready to treasure your memories for a lifetime.</p>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="testimonial-section">
        <div className="section-header">
          <h2 className="section-title">Client Love</h2>
          <div className="title-line"></div>
        </div>
        <div className="testimonial-content">
          <blockquote>
            "Stories by Kalakaar captured our wedding day perfectly. Every photo tells a story, and we couldn't be happier with the results. Their attention to detail and artistic vision is unmatched."
          </blockquote>
          <p className="client-name">- Priya & Rahul</p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="contact-content">
          <h2>Start Your Story With Us</h2>
          <p>Let's create timeless memories together</p>
          <Link to="/contactUs" className="contact-button">
            Get in Touch
          </Link>
        </div>
      </section>

      {/* Associates Section */}
      <section className="associates-section">
        <div className="section-header">
          <h2 className="section-title">Our Associates</h2>
          <div className="title-line"></div>
        </div>
        <div className="associates-grid">
          <div className="associate-logo">
            <img src="/resources/images/knn.webp" alt="Kanpur Nagar Nigam" />
          </div>
          <div className="associate-logo">
            <img src="/resources/images/dhuaan.avif" alt="Dhuaan" />
          </div>
          <div className="associate-logo">
            <img src="/resources/images/landmark.jpeg" alt="Landmark" />
          </div>
          <div className="associate-logo">
            <img src="/resources/images/yi.png" alt="Young Indian" />
          </div>
          <div className="associate-logo">
            <img src="/resources/images/govpun.png" alt="Government of Punjab" />
          </div>
          <div className="associate-logo">
            <img src="/resources/images/flo.png" alt="FICCI FLO" />
          </div>
          <div className="associate-logo">
            <img src="/resources/images/agrow_healthcare_logo.jpeg" alt="Agrow Healthcare" />
          </div>
          <div className="associate-logo">
            <img src="/resources/images/parkside.jpg" alt="Parkside" />
          </div>
          <div className="associate-logo">
            <img src="/resources/images/downtown.jpeg" alt="Downtown" />
          </div>
          <div className="associate-logo">
            <img src="/resources/images/vikalp-aahaar.avif" alt="Vikalp Aahaar" />
          </div>
          <div className="associate-logo">
            <img src="/resources/images/round-table.png" alt="Round Table" />
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <Newsletter />

      <Footer />
    </div>
  );
};